var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8443 9.25H18.3443M2.8443 9.25H4.3443M11.3443 0.75V2.25M5.3338 3.24L6.3938 4.301M17.3543 3.24L16.2933 4.301M11.9998 5.9635C7.5903 9.8125 2.8428 14.6535 1.1563 16.3985C0.7613 16.807 0.6353 17.4025 0.8628 17.9225C0.9868 18.205 1.1333 18.5135 1.2848 18.776C1.4363 19.0385 1.6303 19.3195 1.8133 19.568C2.1493 20.0255 2.7283 20.2135 3.2793 20.076C5.6338 19.4875 12.2003 17.797 17.7383 15.903",
    stroke: "#373A45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39769 8.3463C9.39769 8.3463 10.4432 9.3923 12.2157 12.4623C13.9882 15.5323 14.3712 16.9608 14.3712 16.9608M9.93969 18.4283L10.2367 19.5373C10.3147 19.8285 10.3346 20.1322 10.2952 20.4311C10.2558 20.73 10.158 21.0182 10.0072 21.2793C9.85646 21.5404 9.65576 21.7692 9.41657 21.9527C9.17738 22.1362 8.90439 22.2708 8.61319 22.3488C8.32198 22.4268 8.01826 22.4467 7.71937 22.4073C7.42048 22.3679 7.13227 22.2701 6.8712 22.1193C6.61013 21.9686 6.38131 21.7679 6.1978 21.5287C6.01429 21.2895 5.87969 21.0165 5.80169 20.7253L5.55469 19.8013M11.6147 5.2998C11.6147 5.2998 12.8132 6.6103 15.1977 10.7408C17.5822 14.8713 18.1182 16.5643 18.1182 16.5643",
    stroke: "#373A45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedIconActive);
export default __webpack_public_path__ + "static/media/FeedIconActive.92ac77fb83fd69885e51ba88d8c947b4.svg";
export { ForwardRef as ReactComponent };